import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

// Components
import { EditableCell } from '../EditableCell'
import { StaticCell } from '../StaticCell'
import { ButtonRow } from '../../layout/ButtonRow'

// Constants
import { tableRowStyles } from '../../../_constants/styles'

// Utils
import { buildFormFields } from '../../../_helpers/forms'
import { FormField } from '../../Forms/FormField'

// Styled component
export const S_EditableRow = styled.div`
  ${tableRowStyles}
`

export const EditableRow = (props) => {
  if (!props || !props.entity || !props.fields) {
    return null
  }
  const [formFields, setFormFields] = useState([])

  const {
    entity,
    fields,
    fieldDefaults = {},
    rowNumber = null,
    RowControls = null,
    onChange = () => {},
    onBlur = () => {},
    errors = {},
    readOnly = false,
    onDragOver = () => {},
  } = props

  // Set formalized fields when the row loads
  useEffect(() => {
    setFormFields(buildFormFields(entity, fields, fieldDefaults))
  }, [entity, fields])

  // Entity Id
  const entityId = entity.id

  return (
    <S_EditableRow>
      {/* Row Num */}
      {rowNumber !== null && <StaticCell className="row-number">{rowNumber}</StaticCell>}

      {/* Map Editable Cells */}
      {formFields.map((formField) => {
        const { id, type, label, layout, disabled, Cell = FormField, defaultValue, ...rest } = formField
        let prevValue = defaultValue
        return (
          <EditableCell
            Cell={Cell}
            defaultValue={entity[id]}
            disabled={disabled || readOnly}
            entity={entity}
            error={errors[id] ? errors[id] : null}
            key={id}
            label={label}
            layout={layout}
            name={id}
            onBlur={(ev) => {
              onBlur(entityId, id, ev, entity)
            }}
            onChange={(newValue) => {
              if (newValue && newValue.target) {
                onChange(entityId, id, newValue.target.value, entity)
                prevValue = newValue
              } else {
                onChange(entityId, id, newValue, prevValue, entity)
                prevValue = newValue
              }
            }}
            onDragOver={onDragOver}
            type={type}
            {...rest}
          />
        )
      })}

      {/* Row Controls */}
      {RowControls && (
        <StaticCell className="row-controls">
          <ButtonRow spacingH="2px" spacingV="2px">
            <RowControls entity={entity} entityId={entityId} />
          </ButtonRow>
        </StaticCell>
      )}
    </S_EditableRow>
  )
}
